import React from 'react';
import { Button, Icon, Popup, Table, Header, Divider, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import CreateNewGrade from './CreateNewGrade';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import EditGrade from './EditGrade';


export default class MobilityGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grades: [],
            mob: JSON.parse(localStorage.getItem('mob')),
            limitation: this.props.limitation,
            addGrade: false,
            confirmation: false,
            marks: {},
            showEditMode: false,
            onButtonClick: false,
        };

        this.getMobilityMark = this.getMobilityMark.bind(this);
        this.deleteMark = this.deleteMark.bind(this);
    }

    componentDidMount() {
        this.getMobilityMark();
    }

    getMobilityMark() {
        this.setState({ loader: true });
        axios.get(`/student-mobility-mark/${this.state.mob.id}/`)
            .then(res => {
                let grades = res.data;
                this.setState({ grades });
                this.setState({ loader: false });
            });
    }

    deleteMark(markId, optLock) {
        this.setState({ loader: true });
        let obj = {
            id: markId,
            optLock
        };
        axios.delete(`/student-mobility-mark/delete/${markId}/`, { data: obj })
            .then((res) => {
                this.setState({ loader: false, confirmation: false });
                toast('Uspješno ste izbrisali ocjenu!');
                this.getMobilityMark();
            }).catch(err => {
                this.setState({ loader: false });
                if (err.response.data === 'Student mark is changed!') { toast('Ocjena je izmijenjena u međuvremenu. Pokušajte ponovo!'); } else { toast('Došlo je do greške! Ocjena nije izbrisana!'); }
            });
    }

    render() {
        return (
            <div>
                <Divider horizontal>
                    <Header as="h4">{this.state.mob.universityName}<br />
                        <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>{this.state.mob.country.officialName}</i></span>
                    </Header>
                </Divider>

                {!this.state.onButtonClick && !this.state.limitation && !this.state.showEditMode ?
                    <Header style={IconHeader} floated="right">
                        <Button
                            floated="right"
                            icon
                            labelPosition="right"
                            color="blue"
                            disabled={this.state.limitation || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                            style={FiltersOnStyle}
                            onClick={() => { this.setState({ addGrade: true, onButtonClick: true }); window.scrollTo(0, 0); }}
                        ><Icon className="add" />
                            Dodaj ocjenu
                        </Button></Header>
                    : !this.state.limitation && <br />}


                {this.state.addGrade && <CreateNewGrade
                    getMobilityMark={this.getMobilityMark}
                    closeAddMode={() => this.setState({ addGrade: false, onButtonClick: false })}
                />}


                {this.state.showEditMode &&
                    <EditGrade
                        closeEditMode={() => this.setState({ showEditMode: false })}
                        marks={this.state.marks}
                        getMobilityMark={this.getMobilityMark}
                    />}

                {(this.state.grades.length && !this.state.limitation) ? <div><br /><br /></div> : ''}
                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.grades.length ?
                        <Table celled selectable compact >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                        <Header.Content>
                                            Predmet
                                            <Header.Subheader>B/H/S / engleski jezik / izvorni jezik</Header.Subheader>
                                        </Header.Content>
                                    </Header></Table.HeaderCell>
                                    <Table.HeaderCell >Šifra</Table.HeaderCell>
                                    <Table.HeaderCell width="1">P / V</Table.HeaderCell>
                                    <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                    <Table.HeaderCell >Datum</Table.HeaderCell>
                                    <Table.HeaderCell >Ocjena</Table.HeaderCell>
                                    <Table.HeaderCell >Tip predmeta</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={this.state.confirmation ? 2 : 1} />
                                </Table.Row>
                            </Table.Header>

                            <Table.Body> {this.state.grades.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle" colSpan="2">
                                        {el.courseName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].courseName : '-'} / { el.translations.filter((e) => e.language !== 'en' && this.state.otherLang !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0].courseName : el.translations.filter((e) => e.language === 'en' && this.state.mob.translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0] ? el.translations.filter((e) => e.language === 'en' && this.state.mob.translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0].courseName : '-'}
                                        {/* {el.courseName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].courseName : '-'} / { el.translations.filter((e) => e.language !== 'en' && this.state.otherLang !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0].courseName : el.translations.filter((e) => e.language === 'en' && this.state.mob.translations.find((e) => e.originalLanguage === true))[0] ? el.translations.filter((e) => e.language === 'en' && this.state.mob.translations.find((e) => e.originalLanguage === true))[0].courseName : '-'} */}
                                        {/* {el.courseName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].courseName : '-'} / { el.translations.filter((e) => e.language !== 'en' && this.state.otherLang !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0].courseName : el.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0] ? el.translations.filter((e) => e.language === 'en' && e.originalLanguage === true)[0].courseName : '-'} */}
                                        {/* {el.courseName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].courseName : '-'} / { el.translations.filter((e) => e.language !== 'en' && this.state.otherLang !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0] : el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].courseName:   '-'} */}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.code}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.lectureNumber}/{el.exerciseNumber}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.ects}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {moment(el.date).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.mark.number} ({el.mark.name})
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" >
                                        {el.mandatory ? 'obavezni' : el.mandatory === false ? 'izborni' : null}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle" colSpan={this.state.confirmation ? 2 : 1}>
                                        {this.state.confirmation === index ?
                                            <div>
                                                <h4>Jeste li sigurni?</h4>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    onClick={() => this.deleteMark(el.id, el.optLock)}
                                                > DA</Button>
                                                <Button
                                                    basic="true"
                                                    color="red"
                                                    onClick={(e) => { this.setState({ confirmation: false }); }}
                                                >  NE

                                                </Button>
                                            </div>
                                            : <div>
                                                <Popup
                                                    content="Izmjena ocjene"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={this.state.limitation  || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                            id={index}
                                                            basic="true"
                                                            circular
                                                            icon="pencil"
                                                            size="small"
                                                            color="green"
                                                            onClick={() => { this.setState({ showEditMode: true, marks: { ...el, mandatory: el.mandatory ? 1 : el.mandatory === false ? 2 : null } }); window.scrollTo(0, 0); }}
                                                        />}
                                                />
                                                <Popup
                                                    content="Brisanje ocjene"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            disabled={this.state.limitation  || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                            basic="true"
                                                            circular
                                                            icon="trash alternate"
                                                            size="small"
                                                            color="red"
                                                            onClick={() => this.setState({ confirmation: index })}
                                                        />}
                                                /></div>}
                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : <div><br /><br />Nema unesenih ocjena za odabranu mobilnost.</div>}
                <ToastContainer hideProgressBar />
            </div>);
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/MobilityGrades.js